/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingPrimaryPropertyType =
    (typeof BuildingPrimaryPropertyType)[keyof typeof BuildingPrimaryPropertyType];

export const BuildingPrimaryPropertyType = {
    HouseTownhouseVilla: 1,
    DuplexSemiDetached: 2,
    BoardingHouseGuestHouse: 3,
    ApartmentUnitBlock: 4,
    HotelMotelHostel: 5,
    CaretakersResidenceWithinNonResidential: 6,
    AgedCareFacility: 7,
    RetirementVillage: 8,
    OfficeBuilding: 9,
    GpMedicalPractice: 10,
    RetailShop: 11,
    RestaurantCafeBar: 12,
    Showroom: 13,
    ShoppingCentre: 14,
    CarPark: 15,
    WarehouseStorage: 16,
    FactoryManufacturing: 17,
    LaboratoryWorkshop: 18,
    HospitalHealthcareFacility: 19,
    DaySurgeryMedicalCentre: 20,
    SchoolEducation: 21,
    ChildcareCentre: 22,
    UniversityTafe: 23,
    TheatreAssemblyHall: 24,
    ChurchPlaceOfWorship: 25,
    CommunityHall: 26,
    SportsFacilityStadium: 27,
    TransportTerminal: 28,
    LibraryMuseumGallery: 29,
    ShedGarageCarport: 30,
    SwimmingPoolEnclosure: 31,
    FenceRetainingWall: 32,
    PrivateBushfireShelter: 33,
} as const;
